import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAlert } from 'react-alert';
import UniswapIcon from "../../../../../../assets/images/user_app/uniswap_icon.png";
import WalletIcon from "../../../../../../assets/images/user_app/wallet_icon_4.png";

import CheckMarkIcon from "../../../../../../assets/images/user_app/purple_checkmark.svg";

import { ConnectButton } from "@rainbow-me/rainbowkit";


import { CustomConnectButton } from "../common_components/CustomConnectButton";

function WalletsTable(props) {
    const alert = useAlert()
    const navigate = useNavigate();

    function shortAddress(address) {
        if (address.length > 0) {
            const first = address.substring(0, 6)
            const last = address.substring(address.length - 4, address.length)
            return first + "..." + last
        }
    }


    return (
        <div className="wallets-table-container">
            <div className="wallets-table-header">
                <h2 className="wallets-table-header-text">Wallets</h2>
                <ConnectButton size="small" />
            </div>
            <div className="wallets-table-info-box body-small">Connect and verify more wallets to qualify for more missions.</div>
            <div className="wallets-table-row-container">
                {props.wallets.length > 0 && props.wallets.map((wallet) => (
                    <div className="wallets-table-row" key={wallet.address}>
                        <div className="wallets-table-row-icon-and-address-container">
                            <img src={WalletIcon} alt="Wallet Icon" height="42px" width="42px" />
                            <div className="wallets-table-row-address body-medium">{shortAddress(wallet.address)}</div>
                        </div>
                        <div className="wallets-table-verified-icon-and-text-container">
                            <img src={CheckMarkIcon} alt="Verified Icon" height="16px" width="16px" />
                            <div className="wallets-table-row-status body-small">Verified</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default WalletsTable;